import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import DashboardCards from './DashboardCards';
import ListUsers from './ListUsers';
import CourseEditor from './Course';
import AnalyticButtonClick from './AnalyticButtonClick';
import AnalyticVideoPost from './AnalyticVideoPost';
import UserActivity from './UserActivity';

const DashboardPage = () => {
    // Восстанавливаем выбранную вкладку из localStorage или устанавливаем "Главная" по умолчанию
    const [selectedComponent, setSelectedComponent] = useState(
        localStorage.getItem('selectedTab') || 'Главная'
    );

    // Сохраняем выбранную вкладку в localStorage при изменении
    const handleMenuItemClick = (componentName) => {
        setSelectedComponent(componentName);
        localStorage.setItem('selectedTab', componentName);
    };

    // Определяем страницы для меню
    const pages = [
        { name: 'Главная', icon: 'bxs-dashboard', active: selectedComponent === 'Главная' },
        { name: 'Список пользователей', icon: 'bx-analyse', active: selectedComponent === 'Список пользователей' },
        { name: 'Список блокировок', icon: 'bx-analyse', active: selectedComponent === 'Список блокировок' },
        { name: 'Аналитика нажатий', icon: 'bx-analyse', active: selectedComponent === 'Аналитика нажатий' },
        { name: 'Аналитика видео', icon: 'bx-analyse', active: selectedComponent === 'Аналитика видео' },
        { name: 'Курсы', icon: 'bx bxs-cog', active: selectedComponent === 'Курсы' },
    ];

    // Определение выбранного компонента
    let SelectedComponent;
    if (selectedComponent === 'Главная') {
        SelectedComponent = <DashboardCards />;
    } else if (selectedComponent === 'Список пользователей') {
        SelectedComponent = <ListUsers />;
    } else if (selectedComponent === 'Список блокировок') {
        SelectedComponent = <UserActivity />;
    } else if (selectedComponent === 'Аналитика нажатий') {
        SelectedComponent = <AnalyticButtonClick />;
    } else if (selectedComponent === 'Аналитика видео') {
        SelectedComponent = <AnalyticVideoPost />;
    } else if (selectedComponent === 'Курсы') {
        SelectedComponent = <CourseEditor />;
    }
    
    return (
        <div>
            {/* Передача страниц и обработчика клика в компонент Sidebar */}
            <Sidebar pages={pages} isOpen={true} onItemClick={handleMenuItemClick} />
            <div className='content'>
                <Navbar />
                {/* Отображение выбранного компонента */}
                {SelectedComponent}
            </div>
        </div>
    );
};
export default DashboardPage;